export const INTEGRATION_PROVIDER = {
  GOOGLE_CALENDAR: 'google_calendar',
  ZOOM: 'zoom',
  GOOGLE_MEET: 'google_meet',
  MICROSOFT_TEAMS: 'microsoft_teams',
} as const;

export type IntegrationProviderValue =
  (typeof INTEGRATION_PROVIDER)[keyof typeof INTEGRATION_PROVIDER];

export const INTEGRATION_STATUS = {
  CONNECTED: 'connected',
  NEEDS_REAUTH: 'needs_reauth',
  DISCONNECTED: 'disconnected',
  ERROR: 'error',
} as const;

export type IntegrationStatusValue =
  (typeof INTEGRATION_STATUS)[keyof typeof INTEGRATION_STATUS];

export const SERVICE_MEETING_PROVIDER = {
  ZOOM: 'zoom',
  GOOGLE_MEET: 'google_meet',
  MICROSOFT_TEAMS: 'microsoft_teams',
  MANUAL: 'manual',
} as const;

export type ServiceMeetingProviderValue =
  (typeof SERVICE_MEETING_PROVIDER)[keyof typeof SERVICE_MEETING_PROVIDER];

export const SERVICE_SCHEDULE_SOURCE = {
  INHERIT: 'inherit',
  OVERRIDE: 'override',
} as const;

export type ServiceScheduleSourceValue =
  (typeof SERVICE_SCHEDULE_SOURCE)[keyof typeof SERVICE_SCHEDULE_SOURCE];

export const MEETING_INTEGRATION_BY_PROVIDER: Record<
  ServiceMeetingProviderValue,
  IntegrationProviderValue | null
> = {
  zoom: INTEGRATION_PROVIDER.ZOOM,
  google_meet: INTEGRATION_PROVIDER.GOOGLE_MEET,
  microsoft_teams: INTEGRATION_PROVIDER.MICROSOFT_TEAMS,
  manual: null,
};

export function integrationProviderLabel(provider: IntegrationProviderValue): string {
  switch (provider) {
    case INTEGRATION_PROVIDER.GOOGLE_CALENDAR:
      return 'Google Calendar';
    case INTEGRATION_PROVIDER.ZOOM:
      return 'Zoom';
    case INTEGRATION_PROVIDER.GOOGLE_MEET:
      return 'Google Meet';
    case INTEGRATION_PROVIDER.MICROSOFT_TEAMS:
      return 'Microsoft Teams';
    default:
      return provider;
  }
}
